const React = require('react');
const Caption = require("../../../dumb/Caption/C");
const {BtnWithIcon} = require("../../../dumb/AdminHelpers/Buttons");
const DownloadIcon = require("../../../icons/Download");
const {AdminSelect, AdminDatepicker} = require("../../../dumb/FormInputs");
const withState = require("../../../../utils/withState");
const formatTime = require("mn-utils/formatTime");
const noop = require("mn-utils/noop");
const downloadReportDocument = require("../../../../utils/downloadReportDocument");
const {AdminPageHeader} = require("../../../dumb/AdminHelpers/AdminLayout");

const StatementsBtn = ({text, onClick, disabled}) => (
  <BtnWithIcon
    className="w330-i (sr18-i)>.icon"
    icon={
      <DownloadIcon width={14} height={14} />
    }
    text={text}
    onClick={onClick}
    disabled={disabled}
  />
);

const getFirstDayOfMonth = (date) => {
  if (!date) return;

  const month = date.getMonth();
  const year = date.getFullYear();

  return new Date(year, month, 1, 0, 0, 0);
}

const getToday = () => {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  return new Date(year, month, day, 0, 0, 0);
}

const getLastDayOfMonth = (date) => {
  if (!date) return;

  const month = date.getMonth();
  const year = date.getFullYear();

  const currentDate = new Date();

  if (
    currentDate.getMonth() === month
    && currentDate.getFullYear() === year
  ) {
    return getToday();
  }

  const firstDayOfNextMonth = month + 1 > 11
    ? new Date(year + 1, 0, 1, 0, 0, 0)
    : new Date(year, month + 1, 1, 0, 0, 0);
  return new Date(firstDayOfNextMonth - 1000 * 60 * 60 * 24);
}

const getPastMonthStartAndEnd = () => {
  const today = new Date();

  const firstDayOfPastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1, 0,0, 0);
  const lastDayOfPastMonth = new Date(new Date(today.getFullYear(), today.getMonth(), 1, 0,0, 0).getTime() - 1);

  return {
    firstDayOfPastMonth,
    lastDayOfPastMonth
  };
}

const CurrentPeriod = () => {
  const {firstDayOfPastMonth, lastDayOfPastMonth} = getPastMonthStartAndEnd();

  return (
    <div className="mt60 f16">
      {formatTime(firstDayOfPastMonth, '{dd}.{mm}.{yyyy}', false)} - {formatTime(lastDayOfPastMonth, '{dd}.{mm}.{yyyy}', false)}
    </div>
  )
}

const MIN_DATE = new Date(2022, 0, 1);

const basicChecks = (value, lastDayOfPastMonth) => {
  let error;

  if (!Date.parse(value)) {
    error = 'Must be a date';
  } else if (value > lastDayOfPastMonth) {
    error = `Must be before ${formatTime(lastDayOfPastMonth, '{mm}.{yyyy}', false)}`;
  } else if (value < MIN_DATE) {
    error = `Must be after ${formatTime(MIN_DATE, '{mm}.{yyyy}', false)}`
  }

  return error;
}

const checkDateFromField = ({dateFrom, dateTo, lastDayOfPastMonth}) => {
  let dateFromError = basicChecks(dateFrom, lastDayOfPastMonth);

  if (!dateFromError) {
    if (MIN_DATE < dateTo && dateTo < lastDayOfPastMonth && dateFrom > dateTo) {
      dateFromError = `Must be before ${formatTime(dateTo, '{mm}.{yyyy}', false)}`
    }
  }

  return dateFromError;
}

const checkDateToField = ({dateFrom, dateTo, lastDayOfPastMonth}) => {
  let dateToError = basicChecks(dateTo, lastDayOfPastMonth);

  if (!dateToError) {
    if (MIN_DATE < dateFrom && dateFrom < lastDayOfPastMonth && dateTo < dateFrom) {
      dateToError = `Must be after ${formatTime(dateFrom, '{mm}.{yyyy}', false)}`;
    }
  }

  return dateToError;
}

const checkCustomPeriods = (state, fieldWithChanges) => {
  const errors = {};

  const checks = [{id: 'dateFrom', fn: checkDateFromField}, {id: 'dateTo', fn: checkDateToField}];

  if (fieldWithChanges === 'dateTo') checks.reverse();

  checks.find(({id, fn}) => {
    const error = fn && fn(state);
    if (error) {
      errors[id] = error;
      return true;
    }
  });

  return errors;
}

const CustomPeriod = ({state = {}, setState = noop}) => {
  const {dateFrom, dateTo, lastDayOfPastMonth, errors = {}} = state;

  const saveNewData = (name, value, fieldWithChanges) => {
    const nextState = {...state, [name]: value};
    const errors = checkCustomPeriods(nextState, fieldWithChanges);

    setState({
      [name]: value,
      errors
    });
  }

  const fields = [
    {
      name: 'dateFrom',
      label: 'From',
      minDate: MIN_DATE,
      maxDate: dateTo < MIN_DATE ? lastDayOfPastMonth : dateTo,
      onChange: (name, rawValue) => {
        const value = getFirstDayOfMonth(!!rawValue ? rawValue : MIN_DATE);
        saveNewData(name, value, 'dateFrom');
      }
    },
    {
      name: 'dateTo',
      label: 'To',
      minDate: dateFrom > lastDayOfPastMonth ? MIN_DATE : dateFrom,
      onChange: (name, rawValue) => {
        const value = getLastDayOfMonth(!!rawValue ? rawValue : lastDayOfPastMonth);
        saveNewData(name, value, 'dateTo');
      }
    }
  ];

  return (
    <div className="layoutRow mh-15 ph15>1">
      {fields.map((el, i) => (
        <div className="mt18" key={i}>
          <AdminDatepicker
            format="MM.yyyy"
            disableFuture
            minDate={el.minDate}
            maxDate={el.maxDate}
            label={el.label}
            name={el.name}
            value={state[el.name]}
            views={['month', 'year']}
            onChange={el.onChange || noop}
            showError={errors[el.name]}
            error={errors[el.name]}
          />
        </div>
      ))}
    </div>
  )
}

module.exports = withState((setState, self) => {
  const {firstDayOfPastMonth, lastDayOfPastMonth} = getPastMonthStartAndEnd();

  self.state = {
    ...self.state,
    lastDayOfPastMonth,
    dateFrom: MIN_DATE,
    dateTo: lastDayOfPastMonth,
  }

  return (state) => {
    const periodsList = [
      {id: 'current', name: 'Current period'},
      {id: 'custom', name: 'Custom period'}
    ];

    const activePeriod = state.period || periodsList[0].id;

    const periodsComponents = {
      [periodsList[0].id]: CurrentPeriod,
      [periodsList[1].id]: CustomPeriod
    };

    const PeriodComponent = periodsComponents[activePeriod];

    const downloadFnCtor = (endpoint) => () => {
      let from, to;

      if (activePeriod === periodsList[1].id) {
        from = state.dateFrom;
        to = new Date(new Date(state.dateTo).getTime() + 24*60*60*1000);
      } else {
        from = firstDayOfPastMonth;
        to = lastDayOfPastMonth;
      }

      downloadReportDocument(
        {from, to},
        {},
        {url: `/f2c/v1/admin/dashboard/${endpoint}/`, prefix: 'statements'}
      );
    }

    return (
      <div className="wmax428">
        <AdminPageHeader title="Statements" />

        <div className="mt32">
          <AdminSelect
            label="Period"
            propName="name"
            propValue="id"
            items={[
              {id: 'current', name: 'Current period'},
              {id: 'custom', name: 'Custom period'}
            ]}
            value={activePeriod}
            onChange={(name, value) => {
              setState({period: value})
            }}
          />
        </div>

        {PeriodComponent && (
          <PeriodComponent state={state} setState={setState} />
        )}

        <div className="layoutRow mt60 mh-25 (p25)>1">
          <div>
            <StatementsBtn
              text="Download Aggregate Statements"
              onClick={downloadFnCtor('agg-flow-monthly-statements')}
              disabled={
                activePeriod === periodsList[1].id
                && Object.keys(state.errors || {}).length
              }
            />
          </div>
          <div>
            <StatementsBtn
              text="Download PayThrough Statements"
              onClick={downloadFnCtor('pt-flow-monthly-statements')}
              disabled={
                activePeriod === periodsList[1].id
                && Object.keys(state.errors || {}).length
              }
            />
          </div>
        </div>
      </div>
    )
  }
})
